export const BRAND_NAME = 'Chal247';
export const BRAND_DOMAIN = 'chal247.com';
export const BACKEND_DOMAIN = 'cue88.com';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
